export default {
	plans: {
		title: "Plans et tarifs",
		subtitle: "Choisissez le plan idéal pour votre temple",
		perMonth: "/mois",
		freeTrial: "30 jours d'essai gratuit",
		getStarted: "Commencer",
		empty: "Plans disponibles prochainement",
		emptyDesc: "Nous préparons nos plans. Revenez bientôt !",
		backToStart: "Retour au début",
	},
	builder: {
		foundation: "Base",
		addons: "Options",
		yourPlan: "Votre forfait",
		includedAlways: "Toujours inclus",
		unlimitedChain: "Membres illimités, tout inclus",
		notInclude: "Ne pas inclure",
		total: "Total",
		subscribeNow: "S'abonner maintenant",
		editPlan: "Modifier le forfait",
		editPlanTitle: "Composez votre forfait",
		editDone: "Terminer",
		preselectionUnavailable: "Le forfait ou l'option choisie précédemment n'est plus disponible. Vérifiez la sélection ci-dessous avant de confirmer.",
		startFree: "Essayer 30 jours gratuits",
		trialNote: "Les options ne font pas partie de l'essai gratuit — abonnez-vous pour les activer dès le premier jour.",
		trialConfirm: {
			title: "Essai gratuit de 30 jours",
			message:
				"Pendant l'essai gratuit, vous profitez des fonctions du plan, mais les options (WhatsApp, Mercado Pago) ne sont pas incluses. Pour les utiliser, abonnez-vous à un plan.",
			withAddons:
				"Les options que vous avez choisies ({addons}) ne font pas partie de l'essai gratuit. Abonnez-vous pour les activer dès le premier jour.",
			subscribeInstead: "S'abonner à un plan",
			continueTrial: "Continuer l'essai gratuit",
		},
		optional: "optionnel",
		needMore: "Besoin de plus ? Contactez-nous !",
		needMoreSubject: "J'ai besoin d'un forfait sur mesure",
		group: {
			whatsapp: "Alertes WhatsApp",
			mercadoPago: "Intégration Mercado Pago",
		},
	},
	trial: {
		banner: "Période d'essai : {days} jours restants",
	},
	voucher: {
		label: "Code promotionnel",
		placeholder: "Ex. : ORI2026",
		apply: "Appliquer",
		valid: "Code promotionnel appliqué avec succès !",
		invalid: "Code promotionnel invalide",
		applied: "Remise du code promo",
		activated: "Abonnement activé avec succès !",
	},
	dialog: {
		title: "Choisissez votre plan",
		subtitle: "Sélectionnez un plan pour vous abonner",
		confirm: "Continuer",
		cancel: "Annuler",
	},
	return: {
		checkingTitle: "Confirmation de votre paiement...",
		checkingDesc: "Cela ne prend que quelques secondes.",
		successTitle: "Merci pour votre achat !",
		successDesc: "Votre abonnement est désormais actif.",
		successDescPlan: "Votre abonnement au forfait {plan} est désormais actif.",
		pendingTitle: "Nous confirmons votre paiement",
		pendingDesc: "La confirmation peut prendre quelques minutes. Si le paiement a abouti, votre forfait sera activé automatiquement. S'il n'a pas été finalisé ou a été refusé, vous pouvez réessayer sur la page du forfait.",
		viewMyPlan: "Voir mon forfait",
		goToDashboard: "Aller au tableau de bord",
	},
	blocked: {
		ownerTitle: "Votre abonnement a expiré",
		ownerDesc: "La période d'essai est terminée ou le paiement n'a pas été confirmé. Souscrivez à un plan pour continuer à utiliser ORI.",
		memberTitle: "Accès suspendu",
		memberDesc: "L'accès au système est temporairement suspendu. Contactez le propriétaire du temple pour régulariser l'abonnement.",
		currentTemple: "Temple actuel :",
		otherTemples: "Ou accédez à un autre temple de votre compte :",
		pendingCheckout: "Vous avez commencé à souscrire à un forfait sans finaliser le paiement :",
		resumeCheckout: "Reprendre où je me suis arrêté",
		chooseAnother: "Choisir un autre forfait",
		logout: "Déconnexion",
	},
	page: {
		title: "Mon plan",
		plan: "Plan",
		trialExpiresIn: "L'essai expire dans",
		daysLeft: "({days} jours restants)",
		nextPayment: "Prochain paiement",
		accessUntil: "Accès jusqu'au",
		subscribeNow: "S'abonner maintenant",
		cancelSubscription: "Annuler l'abonnement",
		changePlan: "Changer de forfait",
		paymentHistory: "Historique des paiements",
		noPayments: "Aucun paiement",
		noPaymentsDesc: "Votre historique de paiements apparaîtra ici.",
		headerAmount: "Montant",
		headerStatus: "Statut",
		headerPaidAt: "Payé le",
		headerPeriod: "Période",
		cancelTitle: "Annuler l'abonnement",
		cancelConfirm: "Êtes-vous sûr de vouloir annuler votre abonnement ? L'accès sera maintenu jusqu'à la fin de la période en cours.",
		cancelNo: "Non",
		cancelYes: "Oui, annuler",
		cancelSuccess: "Abonnement annulé. Accès maintenu jusqu'à la fin de la période.",
		errorSubscribe: "Erreur lors de la souscription",
		errorCancel: "Erreur lors de l'annulation de l'abonnement",
		errorLoad: "Erreur lors du chargement des données du plan",
		voucher: {
			comped: "Offert",
			compedUntil: "Offert jusqu'au {date}",
			discountPercent: "Remise de {value} %",
			discountAmount: "Remise de R$ {value}",
			payFullPrice: "Payer le prix complet",
			payFullPriceConfirm: "À partir de la prochaine facture, Mercado Pago facture le prix complet du forfait.",
			back: "Retour",
			payFullPriceSuccess: "Remise terminée.",
			payFullPriceError: "Erreur lors de la fin de la remise",
		},
		status: {
			TRIALING: "Période d'essai",
			ACTIVE: "Actif",
			PAST_DUE: "Paiement en attente",
			SUSPENDED: "Suspendu",
			CANCELLED: "Annulé",
			NO_SUBSCRIPTION: "Aucun abonnement",
		},
		statusDesc: {
			TRIALING: "Vous êtes en période d'essai gratuit.",
			ACTIVE: "Votre abonnement est actif et à jour.",
			PAST_DUE: "Votre dernier paiement a échoué. Veuillez le mettre à jour pour maintenir l'accès.",
			SUSPENDED: "Accès suspendu. Abonnez-vous pour réactiver.",
			CANCELLED: "Abonnement annulé. L'accès reste valable jusqu'à la fin de la période en cours.",
			CANCELLED_EXPIRED: "Abonnement annulé et période terminée. Abonnez-vous pour utiliser ORI à nouveau.",
			NO_SUBSCRIPTION: "Abonnez-vous pour commencer à utiliser ORI.",
		},
		paymentStatus: {
			PAID: "Payé",
			PENDING: "En attente",
			FAILED: "Échoué",
			REFUNDED: "Remboursé",
		},
	},
	usage: {
		title: "Utilisation du forfait",
		unlimited: "illimité",
		estimate: "Le nombre de messages est une estimation et varie selon les fonctionnalités activées.",
		limitKey: {
			corrente: "Membres actifs",
			whatsappMsgMonth: "Messages WhatsApp/mois",
		},
	},
	upgrade: {
		title: "Limite du forfait atteinte",
		cta: "Voir les forfaits",
		defaultMessage:
			"Cette fonctionnalité n'est pas incluse dans votre forfait actuel. Effectuez une mise à niveau pour la débloquer.",
	},
	changePlan: {
		title: "Changer de forfait",
		current: "actuel",
		upgradeNote:
			"Les surclassements prennent effet immédiatement. La différence au prorata des jours restants est ajoutée à la prochaine facture.",
		downgradeNote:
			"Le passage à un forfait inférieur est programmé pour la fin de la période en cours — l'accès continue jusque-là.",
		confirm: "Changer de forfait",
		upgraded: "Forfait changé ! Prorata de R$ {amount} sur la prochaine facture.",
		scheduled: "Changement programmé pour la fin de la période en cours.",
		changed: "Forfait changé avec succès.",
		error: "Erreur lors du changement de forfait",
	},
	addons: {
		title: "Options",
		subtitle: "Fonctionnalités supplémentaires pour votre forfait",
		contracted: "Actif",
		contract: "Ajouter",
		change: "Passer à ce palier",
		remove: "Retirer",
		perMonth: "/mois",
		prorationWarning:
			"Accès activé immédiatement. Le montant au prorata des jours restants sera ajouté à votre prochaine facture ; les suivantes seront au prix plein.",
		contractTitle: "Ajouter une option",
		activated: "Option activée ! Prorata de R$ {amount} sur votre prochaine facture.",
		activatedNoProration: "Option activée !",
		removeTitle: "Retirer l'option",
		removeText:
			"L'option reste active jusqu'à la fin de la période en cours et ne sera pas renouvelée. Aucun remboursement.",
		removeScheduled: "Retrait programmé pour la fin de la période en cours.",
		scheduledForEnd: "Modification programmée pour la fin de la période en cours.",
		pendingProration:
			"R$ {amount} (au prorata) seront ajoutés à votre prochaine facture.",
		hasScheduledChange:
			"Vous avez un changement de forfait programmé pour la fin de la période en cours.",
		error: "Échec de la modification de l'option",
	},
};
